<template lang="html">

  <div class="usluga">
    <div class="headUsluga">


  <router-link class="navbar-brand" to="/ksusluge">Back </router-link>
    <h3>HR Professional Program</h3>
    <p>HR Professional Program jeste mentoring program koji je dizajniran tako da HR zaposleni (kao i početnici koji žele da grade karijeru kroz oblast Upravljanja ljudskim resursima), dosegnu viši nivo u svojoj karijeri prenošenjem znanja, iskustva i metodologije od strane naših konsultanata. Tokom programa obrađuju se sledeće teme: HR uticaj na organizaciju, Selekcija i regrutacija, Implementacija Performance Management-a, Talent Management, Interne komunikacije, Rešavanje konflikta u timovima, HR budžetiranje, Strategija edukacije i razvoja zaposlenih, Employer branding, kao i  Organizaciona struktura i kultura.</p>
    <h5>Potrebna Vam je ova usluga? Popunite polja ispod:</h5>
  </div>

    <div class="card-body">


         <div class="form-group">
           <label for="numberOfEmployees">Broj zaposlenih za koje se vrsi usluga</label>
           <input
             class="form-control"
             type="text"
             placeholder=""
             name="numberOfEmployees"
             v-model="numberOfEmployees"
             id="numberOfEmployees"
             >
         </div>
         <div class="form-group">
           <label for="nameOfPosition">Naziv pozicije zaposlenog za kojeg se vrši usluga<p style="display:inline;color:red">*</p></label>
           <input
             class="form-control"
             type="text"
             placeholder=""
             name="nameOfPosition"
             v-model="nameOfPosition"
             id="nameOfPosition"
             >
         </div>
         <div class="form-group">
           <label for="nameOfEmployee">Ime i prezime zaposlenog/zaposlenih za koje se vrše usluge (ukoliko ih je vise odvojite imena zarezom):<p style="display:inline;color:red">*</p></label>
           <input
             class="form-control"
             type="text"
             placeholder=""
             name="nameOfEmployee"
             v-model="nameOfEmployee"
             id="nameOfEmployee"
             >
         </div>
        <div class="form-group">
          <label for="companyName">Naziv Kompanije<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="companyName"
            v-model="companyName"
            id="companyName"
            >
        </div>
        <div class="form-group">
          <label for="contactName">Ime i Prezime Kontakt Osobe<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="contactName"
            v-model="contactName"
            id="contactName"
            >
        </div>
        <div class="form-group">
          <label for="contactNumber">Kontakt telefon<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="contactNumber"
            v-model="contactNumber"
            id="contactNumber"
            >
        </div>
        <div class="form-group">
          <label for="email">E-mail<p style="display:inline;color:red">*</p></label>
          <input
            class="form-control"
            type="text"
            placeholder=""
            name="email"
            v-model="email"
            id="email"
            >
        </div>



        <div class="validation">
          {{validation}}
        </div>
        <button class="btn btn-primary" @click="submit">Posalji Formular</button>
        &nbsp;&nbsp;&nbsp;&nbsp;



  </div>

  </div>

</template>

<script>
// eslint-disable-next-line no-unused-vars
import {mapActions,mapGetters} from 'vuex';
export default {

  name: 'HRProfessionalProgram',
  components: {

  },
  data(){
    return{
      companyName:"",
  contactName:"",
  contactNumber:"",
  email:"",
  numberOfEmployees :"",
  nameOfPosition:"",
  nameOfEmployee:"",
  validation:"",
  date:"",
    }
  },
  methods:{
  ...mapActions(['submitServiceAplication']),
  submit(){

    this.validation="";

    if(this.companyName==""){
      this.validation="Unesite naziv kompanije."
    }
    if(this.contactName==""){
      this.validation="Unesite ime i prezime kontakt osobe."
    }
    if(this.email==""){
      this.validation="Unesite email."
    }
    if(this.contactNumber==""){
      this.validation="Unesite kontakt telefon."
    }
    if(this.nameOfPosition==""){
      this.validation="Unesite naziv pozicije zaposlenog/zaposlenih."
    }
    if(this.nameOfEmployee==""){
      this.validation="Unesite ime i prezime zaposlenog/zaposlenih."
    }
    const d = new Date();
    let day = d.getDate();
    let month = d.getMonth()+1;
    let year = d.getFullYear();
    this.date= "Datum: "+day+"."+month+"."+year+".";


    let text = [];
    text.push("HR Professional Program");
    text.push(this.date);
    text.push("Broj zaposlenih za koje se vrši usluga: "+this.numberOfEmployees);
    text.push("Naziv pozicije zaposlenog za kojeg se vrši usluga: "+this.nameOfPosition);
    text.push("Ime i prezime zaposlenog/zaposlenih za koje se vrše usluge: "+this.nameOfEmployee);
    text.push("Naziv Kompanije: "+this.companyName);
    text.push("Ime i Prezime Kontakt Osobe: "+this.contactName);
    text.push("Email: "+this.email);
    text.push("Kontakt telefon: "+this.contactNumber  );


    let data ={
      formular:text
    }

    if(this.validation==""){
    this.submitServiceAplication(data);
    this.validation="Uspesno poslat formular."
    }
  },
},

  beforeCreate: function() {
        document.body.className = 'usluge';
  }
}
</script>

<style lang="css" scoped>
.usluga{
  position: absolute;
  top: auto;
  left: 10%;
  right: 10%;
  background-color: white;
  border-style: solid;
  border-color: black;
  border-width: medium;
  border-radius: 15px;
  margin-top: 15px;

}
.headUsluga{
  background-color: #77bbee;
  padding: 10px;
  border-top-left-radius:  10px;
  border-top-right-radius:  10px;
}
.card-body{
  background-color: #bbffff;
  border-bottom-left-radius:  10px;
  border-bottom-right-radius:  10px;
}
.validation{
  margin-top: 5px;
  background-color: #00aaaa;
}
</style>
